// extracted by mini-css-extract-plugin
export default {"spinWrap":"EditListingPage_spinWrap__hjLyC"};